import AttendanceAdapter from './base';

export default class BehaviourIncident extends AttendanceAdapter {
  modelNamePlural = 'behaviourIncidents';
}
